import React from 'react';

interface Props extends React.SVGAttributes<SVGElement> {
  color?: string;
  size?: number;
  variant?: 'default' | 'thick';
}

export const CaretDownIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color = 'currentColor',
  size = 24,
  variant = 'thick',
  ...props
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <line
      x1="5"
      y1="7"
      x2="8"
      y2="10"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={variant === 'thick' ? 2 : 1}
    />
    <line
      x1="8"
      y1="10"
      x2="11"
      y2="7"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={variant === 'thick' ? 2 : 1}
    />
    <style jsx>{`
      svg {
        height: ${size}px;
        width: ${size}px;
        display: block;
      }
    `}</style>
  </svg>
);
